module.exports = __webpack_public_path__ + "img/logo.4d45f3cb.png";